<template>
    <form @submit.prevent="handleUser" v-if="user" class="is-clearfix">
        <h1 class="title is-3">{{ this.editMode ? 'Edit' : 'Create' }} user</h1>
        <div class="columns">
            <div class="column">
                <o-field label="First Name" :type="fieldType('first_name')" :message="getError('first_name')">
                  <template #label>
                    First Name <span style="color: red">*</span>
                  </template>
                    <o-input v-model="user.first_name"/>
                </o-field>

                <o-field label="Last Name" :type="fieldType('last_name')" :message="getError('last_name')">
                  <template #label>
                    Last Name <span style="color: red">*</span>
                  </template>
                    <o-input v-model="user.last_name"/>
                </o-field>

                <o-field label="Email"
                         :type="fieldType('email')"
                         :message="getError('email')"
                >
                  <template #label>
                    Email <span style="color: red">*</span>
                  </template>
                    <o-input
                            type="email"
                            placeholder="company@example.com"
                            v-model="user.email"
                    />
                </o-field>

                <o-field label="Password" :type="fieldType('password')" :message="getError('password')">
                  <template #label>
                    Password <span style="color: red">*</span>
                  </template>
                    <o-input type="password" v-model="user.password" password-reveal :class="'reveal-external'"/>
                </o-field>

                <o-field label="Password confirmation">
                  <template #label>
                    Password confirmation <span style="color: red">*</span>
                  </template>
                    <o-input type="password" v-model="user.password_confirmation" password-reveal :class="'reveal-external'"/>
                </o-field>

                <o-field label="About" :type="fieldType('about')" :message="getError('about')">
                    <o-input maxlength="1000" v-model="user.about" type="textarea"></o-input>
                </o-field>
                <o-tabs >
                    <o-tab-item label="Eficiency Rating Metrics">
                        <div class="tablecontainer">
                            <table class="table table-stripped">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Description</th>
                                        <th>Weight</th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        <tr v-for="item in user.metrics" :key="item">
                                            <td>{{item.name}}</td>
                                            <td>{{item.description}}</td>
                                            <td><input class="form-control" v-model="item.weight" type="number" max="100" style="width:45px">%</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td>{{metricsTotal}} %</td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                    </o-tab-item>
                    <o-tab-item label="Raises">
                        <div class="tablecontainer">
                            <table class="table table-stripped">
                                <thead>
                                    <tr>
                                        <th>Range From</th>
                                        <th>Range To</th>
                                        <th>Raise Increase</th>
                                        <th><a @click="addRaise"> Add </a> </th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        <tr v-for="item in user.raise_data" :key="item">
                                            <td><input class="form-control" v-model="item.from" type="number" max="100">%</td>
                                            <td><input class="form-control" v-model="item.to" type="number" max="100">%</td>
                                            <td><input class="form-control" v-model="item.raise" type="number" max="100">%</td>
                                            <td><a @click="removeRaise(item)"> Remove </a> </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                    </o-tab-item>
                    <o-tab-item label="Bonuses">
                        <div class="tablecontainer">
                            <table class="table table-stripped">
                                <thead>
                                    <tr>
                                        <th>Range From</th>
                                        <th>Range To</th>
                                        <th>Potential Bonus</th>
                                        <th><a @click="addBonus"> Add </a> </th>
                                    </tr>
                                </thead>
                                    <tbody>
                                        <tr v-for="item in user.bonus_data" :key="item">
                                            <td><input class="form-control" v-model="item.from" type="number">%</td>
                                            <td><input class="form-control" v-model="item.to" type="number" >%</td>
                                            <td>$<input class="form-control" v-model="item.bonus" type="number" style="width:60px"></td>
                                            <td><a @click="removeBonus(item)"> Remove </a> </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>
                    </o-tab-item>
                </o-tabs >
            </div>

            <div class="column">

                <o-field label="Hourly Rate" :type="fieldType('hourly_rate')" :message="getError('hourly_rate')">
                    <o-input v-model="user.hourly_rate"/>
                </o-field>

                <o-field label="Monthly Goal" :type="fieldType('monthly_goal')" :message="getError('monthly_goal')">
                    <o-input v-model="user.monthly_goal"/>
                </o-field>

                <o-field label="Role" :type="fieldType('role')" :message="getError('role')">
                  <template #label>
                    Role <span style="color: red">*</span>
                  </template>
                    <o-select :disabled="user.id == currentUserId" placeholder="Select a role" v-model="user.role_id"
                              expanded>
                        <option
                                v-for="role in roles"
                                :value="role.id"
                                :key="role.id">
                            {{ role.name }}
                        </option>
                    </o-select>
                </o-field>

                <o-field label="Status" :type="fieldType('status')" :message="getError('status')">
                    <o-select :disabled="user.id == currentUserId" placeholder="Select a status" v-model="user.blocked"
                              expanded>
                        <option :value="false">Active</option>
                        <option :value="true">Inactive</option>
                    </o-select>
                </o-field>

                <o-field label="Mobile Number (xxx-xxx-xxxx)" :type="fieldType('mobile')" :message="getError('mobile')">
                    <o-input placeholder="xxx-xxx-xxxx" v-model="user.mobile"/>
                </o-field>

                <o-field label="Phone Extension" :type="fieldType('phone_extension')"
                         :message="getError('phone_extension')">
                    <o-input v-model="user.phone_extension"/>
                </o-field>

                <o-field label="Carrier" :type="fieldType('carrier')" :message="getError('carrier')">
                    <o-input v-model="user.carrier"/>
                </o-field>

                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="user.title"/>
                </o-field>

                <p class="control">
                    <uploadcare @update:modelValue="handleUploads" format="object" :multiple="true" ref="ucare"/>
                </p>

                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                    <o-input v-model="user.title"/>
                </o-field>

                <img v-if="user.signature" :src="user.signature" class="signature"/>
                <o-field label="Signature">
                    <uploadcare
                            v-model="user.signature"
                            format="url"
                            :clearable="true"
                            :do-not-store="true"
                            :only-images="true"
                            ref="ucare"
                    />
                </o-field>

                <o-field label="Files">
                    <uploadcare @update:modelValue="handleUploads" format="object" :multiple="true" ref="ucare" />
                </o-field>
            </div>
        </div>

        <div class="field is-grouped is-pulled-right">
            <p class="control">
                <router-link :to="{ name: 'users.index' }" class="button" >Cancel</router-link>
            </p>
            <p v-if="editMode" class="control">
                <button type="button" @click.prevent="confirmCustomDelete" class="button is-danger">Delete</button>
            </p>
            <p class="control">
                <button v-submit="submitting" class="button is-success">Save</button>
            </p>
        </div>

    </form>
</template>

<script>
    import HandlesForm from './../mixins/HandlesForm'
    import {mapGetters, mapActions} from 'vuex'
    import Datepicker from '../components/Datepicker'
    import Uploadcare from './Uploadcare'

    export default {
        mixins: [HandlesForm],

        props: {
            editMode: {
                required: false,
                default: false
            }
        },

        components: {
            Uploadcare,
            Datepicker
        },

        computed: {
            ...mapGetters(['currentUserId', 'allRoles']),
            metricsTotal() {
                return this.user.metrics.map(p => +p.weight).reduce((a,b) => a+b)
            },

            roles() {
              return this.allRoles
            },
        },

        data() {
            return {
                user: null,

                metrics: [
                    { key: 'billing', name : 'Billing', description: 'Calculated from billing percent', weight: 40 },
                    { key: 'accuracy', name : 'Accuracy', description: 'Accuracy of billing estimated dates', weight: 25 },
                    { key: 'timelog', name : 'Time Log Completeness', description: 'Calculated from time log percent', weight: 30 },
                    { key: 'nonbillable', name : 'Non billable CO', description: 'Non billable change orders', weight: 5 },
                ],
                raise_data: [
                    { from: 0, to: 25, raise: 0},
                    { from: 26, to: 50, raise: 2},
                    { from: 51, to: 75, raise: 5},
                    { from: 76, to: 100, raise: 8},
                ],
                bonus_data: [
                    { from: 0, to: 100, bonus: 0},
                    { from: 101, to: 120, bonus: 100},
                    { from: 121, to: 999, bonus: 150},
                ]
            }
        },
        mounted() {
            if (this.editMode) {
                this.fetchUserById(this.$route.params.slug)
                    .then(response => {
                        this.user = response.data.data
                        return response
                    })

              this.fetchUserById(this.$store.state.auth.currentUserId)
                  .then(response => {
                      if (response.data.data.role !== "admin"){
                        $("form").find("input").attr("disabled", true)
                        $("form").find("select").attr("disabled", true)
                        $("form").find("textarea").attr("disabled", true)
                        $("form").find("button").attr("disabled", true)
                        $(".tablecontainer").find("a").css("display", "none")
                      }
                  })

              this.fetchRoles()
            } else {
              this.fetchRoles()

                this.user = {
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    password_confirmation: '',
                    status: '',
                    mobile: '',
                    carrier: '',
                    title: '',
                    about: '',
                    signature: '',
                    hourly_rate: 0,
                    monthly_goal: null,
                    metrics: this.metrics,
                    bonus_data: this.bonus_data,
                    raise_data: this.raise_data
                }
            }
        },

        methods: {
            ...mapActions(['createOrUpdateUser', 'fetchUserById', 'createFile', 'fetchRoles']),

            handleUser() {
                let submit = this.wrapSubmit(this.createOrUpdateUser)
                submit(this.user)
                    .then(res => {
                        this.successMessage('User ' + (this.editMode ? 'updated' : 'created') + ' successfull')
                        if (!this.user.id) {
                            this.$router.push(`/users/${res.data.data.id}/edit`)
                        }
                        this.user.password = ''
                        this.user.password_confirmation = ''
                        return res
                    })
            },

            handleUploads(files) {
                if (!files) return

                if (!Array.isArray(files)) {
                    files = [files]
                }

                let promises = []

                files.forEach((file) => {
                    let promise = this.createFile({
                        user_id: this.currentUserId,
                        uuid: file.uuid,
                        path: file.cdnUrl,
                        name: file.name,
                        mime: file.mimeType,
                        size: file.size,
                        reference_id: this.referenceId,
                        reference_type: 'user'
                    })
                    promises.push(promise)
                })

                if (promises.length) {
                    Promise.all(promises).then(() => {
                        this.$refs.ucare.clear()
                    })
                }
            },

            confirmCustomDelete() {
                this.confirmMessage(
                    'Deleting User',
                    'Are you sure you want to <strong>delete</strong> this user? This action cannot be undone.',
                    'Delete User'
                ).then(() => {
                    this.removeUser()
                        .then(res => {
                            this.successMessage('Company deleted!')
                            this.$router.push('/users')
                            return res
                        })
                })
            },
            addRaise() {
                this.user.raise_data.push({ from: 0, to: 0, raise: 0})
            },
            removeRaise(item) {
                this.user.raise_data.splice(this.user.raise_data.indexOf(item), 1)
            },
            addBonus() {
                this.user.bonus_data.push({ from: 0, to: 0, bonus: 0})
            },
            removeBonus(item) {
                this.user.bonus_data.splice(this.user.bonus_data.indexOf(item), 1)
            }
        }
    }
</script>

<style>
.tablecontainer .table tr:nth-child(even) {background-color: #f2f2f2;}
.tablecontainer .table tr:nth-child(odd) {background-color: #fff;}
.tablecontainer .table thead { border-bottom: 1px solid #f0f0f0}
.tablecontainer .table { border: none!important; }
.tablecontainer .table .center-switch { width: 179px; text-align: center!important;}
.tablecontainer tr.no-padding td { padding: 17px 9px; font-weight: bold; background-color: #e3e7ed; min-width: 165px; }
.tablecontainer  td.td-description { width: 100%; }
.tablecontainer input { width: 50px;}
</style>
